module.exports = __webpack_public_path__ + "img/symbol_8.34b4ebf5.png";